import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('../views/Business.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/teacher',
    name: 'Teacher',
    component: () => import('../views/Teacher.vue')
  },
  {
    path: '/about/conpany',
    name: 'Company',
    component: () => import('../views/About/Conpany.vue')
  },
  {
    path: '/about/strategy',
    name: 'AIStrategy',
    component: () => import('../views/About/AIStrategy.vue')
  },
  {
    path: '/courseDetail',
    name: 'CourseDetail',
    component: () => import('../views/CourseDetail.vue')
  },
  {
    path: '/applyCourse',
    name: 'ApplyCourse',
    component: () => import('../views/ApplyCourse.vue')
  },
  {
    path: '/page',
    name: 'Page',
    component: () => import('../views/Page.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router